import React, { useState } from 'react';
import { BrainCircuit, Activity, HeartPulse, Sparkles, Settings, Target, ArrowRight, CheckCircle, X } from 'lucide-react';

export default function AthleteHelpTour({ run, onFinish }) {
  const [currentStep, setCurrentStep] = useState(0);

  if (!run) return null;

  const steps = [
    {
      icon: <Sparkles size={48} color="#00e5ff" />,
      title: '¡Bienvenido a tu nueva era!',
      content: 'Hemos diseñado este panel como tu Centro de Mando Personal. Vamos a darte un rápido paseo de 30 segundos para que descubras todo el potencial de la Inteligencia Artificial y las métricas biocéntricas.'
    },
    {
      icon: <Activity size={48} color="#f59e0b" />,
      title: 'Predisposición Diaria',
      content: 'Esta es tu "batería" para hoy. Analizamos tu sueño, tu VFC (HRV) y tu fatiga acumulada para decirte si estás listo para un entrenamiento duro o si deberías descansar.'
    },
    {
      icon: <HeartPulse size={48} color="#ef4444" />,
      title: 'Tres Dimensiones',
      content: 'Navega entre tu Rendimiento Deportivo (Strava), tu Salud Biocéntrica (Apple Health / Google Health / Withings) y tus Objetivos usando los botones centrales de la pantalla.'
    },
    {
      icon: <Target size={48} color="#00e5ff" />,
      title: 'Objetivos Inteligentes',
      content: 'Crea tus propios objetivos personalizados: distancia, tiempo, sesiones o desnivel, por semana, mes o año. Elige tu deporte favorito y la app calculará tu progreso automáticamente desde tus actividades reales.'
    },
    {
      icon: <BrainCircuit size={48} color="#8b5cf6" />,
      title: 'Tu Fisiólogo IA',
      content: '¡El corazón de la plataforma! Haz clic en el botón flotante en cualquier momento para pedir consejo sobre tu entrenamiento, analizar tus gráficas o preguntar si puedes correr esa tarde.'
    },
    {
      icon: <Settings size={48} color="#10b981" />,
      title: 'Menú y Personalización',
      content: 'Abre el menú de tu Foto de Perfil (arriba a la derecha) para personalizar qué módulos quieres ver en tu pantalla, conectar dispositivos de salud, o cambiar al modo oscuro.'
    }
  ];

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onFinish();
    }
  };

  const step = steps[currentStep];

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'rgba(5, 8, 16, 0.8)', backdropFilter: 'blur(8px)', animation: 'fadeIn 0.3s ease'
    }}>
      <div className="glass-panel" style={{
        maxWidth: '450px', width: '90%', padding: '2.5rem', display: 'flex', flexDirection: 'column',
        alignItems: 'center', textAlign: 'center', position: 'relative'
      }}>
        <button 
          onClick={onFinish}
          style={{ position: 'absolute', top: '1rem', right: '1rem', background: 'transparent', border: 'none', color: 'var(--text-muted)', cursor: 'pointer' }}
        >
          <X size={24} />
        </button>

        <div style={{ marginBottom: '1.5rem', animation: 'fadeInUp 0.4s ease' }} key={`icon-${currentStep}`}>
          {step.icon}
        </div>
        
        <h2 style={{ fontSize: '1.5rem', fontWeight: 800, color: 'white', marginBottom: '1rem', animation: 'fadeInUp 0.5s ease' }} key={`title-${currentStep}`}>
          {step.title}
        </h2>
        
        <p style={{ fontSize: '1.05rem', lineHeight: '1.6', color: 'var(--text-secondary)', marginBottom: '2rem', animation: 'fadeInUp 0.6s ease' }} key={`content-${currentStep}`}>
          {step.content}
        </p>

        {/* Step Indicators */}
        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '2rem' }}>
          {steps.map((_, idx) => (
            <div key={idx} style={{
              width: idx === currentStep ? '24px' : '8px', height: '8px', borderRadius: '4px',
              background: idx === currentStep ? 'linear-gradient(135deg, #00e5ff, #8b5cf6)' : 'rgba(255,255,255,0.1)',
              transition: 'all 0.3s ease'
            }} />
          ))}
        </div>

        <button 
          onClick={handleNext}
          style={{
            background: 'linear-gradient(135deg, #00e5ff, #8b5cf6)', color: 'white', border: 'none',
            padding: '1rem 2rem', borderRadius: '12px', fontSize: '1.1rem', fontWeight: 600,
            cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem', width: '100%', justifyContent: 'center',
            boxShadow: '0 8px 25px rgba(0, 229, 255, 0.3)'
          }}
        >
          {currentStep < steps.length - 1 ? (
            <>Siguiente <ArrowRight size={20} /></>
          ) : (
            <>¡Empezar a Entrenar! <CheckCircle size={20} /></>
          )}
        </button>
      </div>
    </div>
  );
}
